// extracted by mini-css-extract-plugin
module.exports = {"list":"DropdownActionsList_list_ori3b","field":"DropdownActionsList_field_3OzIy"};